export const whereToBuyData = {
    projectHeading: 'The Where To Buy Project',
    projectMainImage: {
        image: '/images/portfolio/where-to-buy/results-page-default.jpg',
        alt: 'Where To Buy Search Page'
    },
    additionalImages: [
        {
            fullImage: '/images/portfolio/where-to-buy/results-mobile.jpg',
            image: '/images/portfolio/where-to-buy/results-mobile-thumb.jpg',
            alt: 'Results Mobile Page'
        },
        {
            fullImage: '/images/portfolio/where-to-buy/results-page-default.jpg',
            image: '/images/portfolio/where-to-buy/results-page-default-thumb.jpg',
            alt: 'Default Results Page'
        },
        {
            fullImage: '/images/portfolio/where-to-buy/results-page-filtered.jpg',
            image: '/images/portfolio/where-to-buy/results-page-filtered-thumb.jpg',
            alt: 'Results Page Filtered Results'
        },
        {
            fullImage: '/images/portfolio/where-to-buy/results-page-selected.jpg',
            image: '/images/portfolio/where-to-buy/results-page-selected-thumb.jpg',
            alt: 'Results Page Selected Items'
        },
        {
            fullImage: '/images/portfolio/where-to-buy/search-default.jpg',
            image: '/images/portfolio/where-to-buy/search-default-thumb.jpg',
            alt: 'Where To Buy Home Page'
        },
        {
            fullImage: '/images/portfolio/where-to-buy/search-mobile.jpg',
            image: '/images/portfolio/where-to-buy/search-mobile-thumb.jpg',
            alt: 'Search Page Mobile'
        },
        {
            fullImage: '/images/portfolio/where-to-buy/search-selected.jpg',
            image: '/images/portfolio/where-to-buy/search-selected-thumb.jpg',
            alt: 'Search Page Selected Items'
        },
    ],
    aboutHeading: 'About the Where To Buy Project',
    aboutPortfolioText: [
        `The Where To Buy (referred to in the rest of this as W2B) project was for the company, Masonite International. Masonite International specialized in building doors comprised of a material called masonite,
         and then selling the doors to distributors which would then be sold to various entities (homeowners, builders, etc.). Doors are sold all around the world; with factories
         existing in various countries to meet the demand.`,

        `The W2B Project was a project aimed at giving various customers a way to search for dealers within within America or Canada on an interactive map.
         This was to make it easier for various campaigns to help drive users to find the door they were looking for from distributors in their respective location.`
    ],
    websiteGoalsHeading: 'Website Goals',
    websiteGoalsText: [
        `The purpose of the W2B Project was to provide an avenue for users to find dealers who carry Masonite doors in a given area. This project was a real challenge,
         as there were four members on my team, with one of which was a newly hired contractor. On top of this, Covid-19 occured in the midst of this,
         and two of the members (myself included) had babies born. Despite these challenges, the project was delivered on time.`
    ],
    websiteGoalsListHeading: 'Website Goals List',
    websiteGoalsList: [
        `Build an interactive map to allow the users to find dealers within a given radius of a longitude/latitude`,
        `Display the product info for a user if they came from a catalogue`,
        `Contain localization for Canada`,
        `Build a real-time data sync for active dealers`,
        `Capture user actions in the URL for bookmarking`,
        `Be mobile friendly`,
        `Analytics to track various user interactions`,
        `Deliver the project in under 2 and a half months with a hard deadline, and with 3 and a half months of work projected`
    ],
    myRoleHeading: 'My Role On The W2B Project',
    position: 'Lead Frontend Web Developer & Scrum Master',
    company: 'Masonite International',
    timeWithCompany: '3 years 1 month',
    myRoleText: [
        `My position within the company was split between two teams. Initially, I joined as a React developer and worked
        with a team to build multiple React/Java applications that allowed distributors to manage the pricing of doors. During this time,
        I would train juniors and set up processes (like PR reviews and Unit Testing) to improve the team's overall quality.
        `,

        `After being in the company for a while, I was asked to help out a different team, as they were struggling to meet their
        deadlines. There was a lot of tension on the team between some of the developers and the manager. I was able to help the team
        work through a lot of the issues, and was moved into the role of lead on the team. Eventually, we took on the W2B Project which this page is about.
        `
    ],
    jobSummaryIntro: 'Following is a summary of my responsibilities while working with Masonite International',
    jobSummaryList: [
        `Build and maintain React applications (7 react apps)`,
        `Develop and contribute to a design language system`,
        `Train juniors`,
        `Develop processes to improve overall team performance`,
        `Rebuild a team that was collapsing`,
        `Add features in a Wordpress website`,
        `Troubleshoot and debug existing systems`,
        `Lead a team of developers`,
        `Manage and deploy code from vendors`,
        `Work closely with the manager to strengthen the team`,
        `Interact with the designer to make sure mockups are followed`,
        `Build and deploy apps following company CI/CD processes`,
    ],
    technologiesUsedIntro: `This section contains the technologies used for building the Masonite International system.`,
    technologiesList: [
        `React`,
        `HTML5`,
        `CSS3`,
        `PHP`,
        `Laravel`,
        `Wordpress`,
        `Java Integration`,
        `Jenkins`,
        `Google Cloud`,
        `Storybook`,
        `Jira`,
        `Git`,
        `Bitbucket`,
        `Responsive Design`,
        `Photoshop`,
        `Google Analytics`,
        `Sass`,
        `Gulp`,
        `Express.js`,
        `Node`
    ]
}